import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";

const { Text } = Typography;

function AdvanceRefundCard({ pendingData, receivedData }) {
  return (
    <Card className="hp-border-radius hp-shadow-sm">
      <Row gutter={[16, 16]}>
        
        {/* Pending Section */}
        <Col span={12}>
          <Card
            size="small"
            style={{ background: "#fff1f0", border: "1px solid #ffa39e" }}
          >
            <Text strong style={{ color: "#cf1322" }}>
              Pending Refund
            </Text>

            <div style={{ marginTop: 10 }}>
              <Text>
                Count:{" "}
                <strong>{pendingData?.pending_count || 0}</strong>
              </Text>
            </div>

            <div>
              <Text>
                Amount: ₹{" "}
                <strong>{pendingData?.pending_amount || 0}</strong>
              </Text>
            </div>
          </Card>
        </Col>

        {/* Received Section */}
        <Col span={12}>
          <Card
            size="small"
            style={{ background: "#f6ffed", border: "1px solid #b7eb8f" }}
          >
            <Text strong style={{ color: "#389e0d" }}>
              Advance Received
            </Text>

            <div style={{ marginTop: 10 }}>
              <Text>
                Count:{" "}
                <strong>{receivedData?.received_count || 0}</strong>
              </Text>
            </div>

            <div>
              <Text>
                Amount: ₹{" "}
                <strong>{receivedData?.received_amount || 0}</strong>
              </Text>
            </div>
          </Card>
        </Col>

      </Row>
    </Card>
  );
}

export default AdvanceRefundCard;
